import React from "react";
import { IPetsyAnnualLimitBonusAppliedPopupProps } from "./PetsyAnnualLimitBonusAppliedPopup.types";
import {
  Modal,
  Image,
} from "react-bootstrap";
import "./PetsyAnnualLimitBonusAppliedPopup.scss";
import _ from "lodash";

export default function PetsyAnnualLimitBonusApplied(props: IPetsyAnnualLimitBonusAppliedPopupProps) {
  function modalClose() {

  }

  function OnClickCloseModal() {
    props.onClose();
  }

  const optionRef = React.useRef<any>();

  function GetContent() {
    if (props.petagecategory < 3) {
      return (
        <>
          <div>
            <Image className="" src={`/images/annual-limit-${props.pettype}-20.png`} />
          </div>
          <div className="modal-text text-style-3 text-left mt-2">Starting early with <strong>Petsy Pet Insurance</strong> has it’s perks.
            For pets starting their protection with us before they’re 6 months old, we’ve topped up your chosen annual limit by 20% and you pay nothing extra.
          </div>
          <div className="modal-text text-style-3 mt-2 text-left">
            That’s an extra $1,000 on a $5,000 plan<br />
            Or an extra $2,000 on a $10,000 plan<br />
            Or an extra $5,000 on a $25,000 plan<br />
          </div>
          <div className="modal-text text-style-3 mt-2  text-left">
            The 20% annual limit bonus is valid for pets starting their protection between 6 weeks and 6 months of age. Enjoy your bonus for the lifetime of the policy that it remains active.
          </div>
        </>
      )
    } else {
      return (
        <>
          <div>
            <Image className="" src={`/images/annual-limit-${props.pettype}-10.png`} />
          </div>
          <div className="modal-text text-style-3 text-left mt-2">Starting early with <strong>Petsy Pet Insurance</strong> has it’s perks.
            For pets starting their protection with us before they turn one, we’ve topped up your chosen annual limit by 10% and you pay nothing extra.
          </div>
          <div className="modal-text text-style-3 mt-2 text-left">
            That’s an extra $500 on a $5,000 plan<br />
            Or an extra $1,000 on a $10,000 plan<br />
            Or an extra $2,500 on a $25,000 plan<br />
          </div>
          <div className="modal-text text-style-3 mt-2  text-left">
            The 10% annual limit bonus is valid for pets starting their protection between 6 months and 1 year of age. Enjoy your bonus for the lifetime of the policy that it remains active.
          </div>
        </>
      )
    }

  }
  return (
    <>
      <Modal
        {...props}
        className="flc_petsy-annual-limit"
        show={props.show}
        onHide={modalClose}
        backdrop="static"
        keyboard={false}
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton onClick={OnClickCloseModal}></Modal.Header>
        <Modal.Body className="text-center" ref={optionRef}>
          <div className="modal-text title">LITTLE PET, BIG PERK</div>
          <div className="modal-text text-style-2">{props.petagecategory < 3 ? '20' : '10'}% Annual Limit Bonus Applied</div>
          {GetContent()}
          <div className="modal-text bottom-award">
            <div className="logo"><Image className="" src="/images/CANSTAR-2023-2025-winner.png" /></div>
            <div className="description">Winner of Canstar's Outstanding Value Pet Insurance Award for <br />2023 & 2024 & 2025</div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
